import { createValidation } from '_metronic/helpers'
import { TFunction } from '_metronic/i18n/Metronici18n'
import * as Yup from 'yup'

export const faturaAtendimentosSchema = (t: TFunction) => {
  const v = createValidation(t)

  return Yup.object().shape({
    observacao: Yup.string().trim().max(512, v.maxField(512)).nullable().notRequired(),
    valorEmpresa: Yup.number()
      .transform((value, originalValue) =>
        originalValue === '' || originalValue === null ? undefined : value
      )
      .when('action', {
        is: 'atualizar',
        then: (schema) =>
          schema.required(v.requiredField('valor_empresa')).min(1, v.minValueField(1)),
        otherwise: (schema) => schema.notRequired(),
      }),
    valorProfissional: Yup.number()
      .transform((value, originalValue) =>
        originalValue === '' || originalValue === null ? undefined : value
      )
      .when('action', {
        is: 'atualizar',
        then: (schema) =>
          schema.required(v.requiredField('valor_profissional')).min(1, v.minValueField(1)),
        otherwise: (schema) => schema.notRequired(),
      }),
    action: Yup.string().oneOf(['atualizar', 'inativar']).required(),
  })
}
